import React, { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getPnlHistory } from "../api";

export default function PnlChart({ strategyId, refreshMs = 15000 }) {
  const [points, setPoints] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => {
      getPnlHistory(strategyId)
        .then((res) => {
          if (!alive) return;
          const history = res.data.history || [];
          setPoints(
            history.map((h) => ({
              time: new Date(h.ts).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }),
              pnl: h.pnl,
            }))
          );
        })
        .catch((err) => alive && setError(err.response?.data?.detail || err.message));
    };
    load();
    const id = setInterval(load, refreshMs);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [strategyId, refreshMs]);

  if (error) return <p className="banner error">{error}</p>;
  if (points.length < 2) return <p className="muted">Not enough data yet for a chart.</p>;

  return (
    <div style={{ width: "100%", height: 200 }}>
      <ResponsiveContainer>
        <LineChart data={points}>
          <CartesianGrid strokeDasharray="3 3" stroke="#2a2f3a" />
          <XAxis dataKey="time" stroke="#7b8291" fontSize={11} />
          <YAxis stroke="#7b8291" fontSize={11} />
          <Tooltip
            contentStyle={{ background: "#171a21", border: "1px solid #2a2f3a", fontSize: 12 }}
          />
          <Line type="monotone" dataKey="pnl" stroke="#2b6cff" dot={false} strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
